import {useCallback, useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import type {ModalProps} from 'components/Modal';
import {useIVCompleted} from 'hooks/iv/useIVCompleted';
import {useGetGuestId} from 'hooks/useGetGuestId';
import phoneCompleted from 'assets/img/phone-completed.svg?no-inline';
import redirectToDesktop from 'assets/img/redirect-to-desktop.svg?no-inline';
import {Button} from '@guestapp/old-ui-kit';
import {VerificationCompletedContext} from './context';
import {Block, StatusText, InstructionText, Picture, StyledModal} from './styled';

export const VerificationCompletedModal = (props: ModalProps) => {
  const {proceed} = useContext(VerificationCompletedContext);
  const {t} = useTranslation();
  const [isReturnToDesktop, setReturnToDesktop] = useState(false);
  const {returnToDesktop, continueOnPhone} = useIVCompleted();
  const guestId = useGetGuestId();
  const isOnlyVerification = Boolean(guestId);

  const returnToDesktopHandler = useCallback(() => {
    setReturnToDesktop(true);
    returnToDesktop();
  }, [returnToDesktop]);

  const continueOnPhoneHandler = useCallback(() => {
    proceed();
    continueOnPhone();
  }, [continueOnPhone, proceed]);

  useEffect(() => {
    if (props.open && isOnlyVerification) {
      returnToDesktop();
    }
  }, [isOnlyVerification, props.open, returnToDesktop]);

  return (
    <StyledModal {...props}>
      {isOnlyVerification ? (
        <>
          <Block>
            <Picture src={redirectToDesktop} />
            <StatusText>{t('identity_verification_is_completed')}</StatusText>
            <InstructionText>
              {t('return_to_your_computer_to_review_your_details')}
            </InstructionText>
            <InstructionText>{t('you_can_close_this_page')}</InstructionText>
          </Block>
        </>
      ) : !isReturnToDesktop ? (
        <>
          <Block>
            <Picture src={phoneCompleted} />
            <StatusText>{t('identity_verification_is_completed')}</StatusText>
            <InstructionText>{t('continue_with_check_in_form')}</InstructionText>
          </Block>
          <Block>
            <Button
              onClick={continueOnPhoneHandler}
              label={t('continue_on_phone')}
              outlined
            />
            <Button
              onClick={returnToDesktopHandler}
              label={t('return_to_desktop')}
              outlined
            />
          </Block>
        </>
      ) : (
        <Block>
          <Picture src={redirectToDesktop} />
          <StatusText>
            {t('continue_your_registration_process_on_your_computer')}
          </StatusText>
          <InstructionText>{t('you_can_close_this_page')}</InstructionText>
        </Block>
      )}
    </StyledModal>
  );
};
